import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_API_BASE_URL
const API_KEY: any = process.env.REACT_APP_API_KEY
export const LISTBANK_URL = `${API_URL}/v1/ekyc/bank-branch`

const listBank = async (val?: any) => {
  try {
    const response = await axios.post(LISTBANK_URL, val, {
      headers: {
        'x-api-key': API_KEY,
        'Access-Control-Allow-Origin': '*',
      },
    })

    return response.data
  } catch (error) {
    console.log(error)
  }
}

export default listBank
